module.exports = __webpack_public_path__ + "images/Consents_SS_1171542352_7c12402.jpg";